import { PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';

type DivideProps = PropsWithChildren<{
  as?: 'div' | 'ul';
  className?: string;
  ariaLabel?: string;
  ariaLabelledby?: string;
  spacing?: 'normal' | 'compact' | 'loose';
}>;

const spacingClasses = {
  normal: '*:py-4',
  compact: '*:py-2',
  loose: '*:py-6',
} as const satisfies Record<NonNullable<DivideProps['spacing']>, string>;

export default function Divide({
  children,
  className,
  as: Element = 'div',
  ariaLabel,
  ariaLabelledby,
  spacing = 'normal',
}: DivideProps) {
  return (
    <Element
      aria-label={ariaLabel}
      aria-labelledby={ariaLabelledby}
      className={twMerge(
        'flex flex-col divide-y divide-outline-variant *:first:pt-0 *:last:pb-0',
        spacingClasses[spacing],
        className,
      )}
    >
      {children}
    </Element>
  );
}
